import React, { useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

import { SDK } from '@betwixt/common';
import { OAuth } from '@betwixt/common/utils/auth.js';

import Loading from '@betwixt/common/components/Loading.js';
import ModulesEmitters from './components/ModulesEmitters.js';
import Portal from './components/Portal.js';

import Error from './components/Error.js';
import Router from './components/router/index.js';

const App = (props) => {
  const [loaded, setLoaded] = useState(false);
  const client = useApolloClient();

  useEffect(() => {
    const initApp = async () => {
      SDK.init();
      const check = await OAuth.init(client);

      if (check) {
        setLoaded(true);
      }
    };

    initApp();
  }, [client]);

  if (loaded) {
    return (
      <div className="App">
        <ModulesEmitters {...props} />

        <Error {...props} />

        <Router {...props} />

        <Portal {...props} />
      </div>
    );
  }

  return <Loading type="ring" />;
};

export default App;
